// // src/features/reviewApproval/reviewApprovalSlice.js

// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// // Async thunk to call POST /api/pdestatus/upsert
// export const upsertPdeStatus = createAsyncThunk(
//   "reviewApproval/upsertPdeStatus",
//   async (
//     { pdeId, dcode, srocode, statusCode, remark, updatedBy },
//     { rejectWithValue }
//   ) => {
//     try {
//       const response = await fetch("/api/pdestatus/upsert", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           pdeId,
//           dcode,
//           srocode,
//           statusCode,
//           remark,
//           updatedBy,
//         }),
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         return rejectWithValue(errorData.message || "Failed to upsert status");
//       }

//       return await response.json();
//     } catch (err) {
//       return rejectWithValue(err.message);
//     }
//   }
// );

// const reviewApprovalSlice = createSlice({
//   name: "reviewApproval",
//   initialState: {
//     loading: false,
//     error: null,
//     message: null,
//   },
//   reducers: {
//     clearReviewError(state) {
//       state.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(upsertPdeStatus.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//         state.message = null;
//       })
//       .addCase(upsertPdeStatus.fulfilled, (state, action) => {
//         state.loading = false;
//         state.message = action.payload.message;
//       })
//       .addCase(upsertPdeStatus.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload || action.error.message;
//       });
//   },
// });

// export const { clearReviewError } = reviewApprovalSlice.actions;
// export default reviewApprovalSlice.reducer;

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import API_BASE_URL from "../BaseURL/baseURL";

// 1) Initialization thunk: only inserts if PDE_ID does not exist yet
export const initPdeStatus = createAsyncThunk(
  "reviewApproval/initPdeStatus",
  async ({ pdeId, dcode, srocode, updatedBy }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_BASE_URL}/pdestatus/init`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ pdeId, dcode, srocode, updatedBy }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        return rejectWithValue(
          errorData.message || "Failed to initialize status"
        );
      }

      return await response.json();
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

// 2) Upsert thunk remains as before (status → 0/1/2/3)
export const upsertPdeStatus = createAsyncThunk(
  "reviewApproval/upsertPdeStatus",
  async (
    { pdeId, dcode, srocode, statusCode, remark, updatedBy },
    { rejectWithValue }
  ) => {
    try {
      const response = await fetch(`${API_BASE_URL}/pdestatus/upsert`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          pdeId,
          dcode,
          srocode,
          statusCode,
          remark,
          updatedBy,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        return rejectWithValue(errorData.message || "Failed to upsert status");
      }

      return await response.json();
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const reviewApprovalSlice = createSlice({
  name: "reviewApproval",
  initialState: {
    loading: false,
    error: null,
    message: null,
  },
  reducers: {
    clearReviewError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // initPdeStatus
    builder
      .addCase(initPdeStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.message = null;
      })
      .addCase(initPdeStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload.message;
      })
      .addCase(initPdeStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });

    // upsertPdeStatus
    builder
      .addCase(upsertPdeStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.message = null;
      })
      .addCase(upsertPdeStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload.message;
      })
      .addCase(upsertPdeStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const { clearReviewError } = reviewApprovalSlice.actions;
export default reviewApprovalSlice.reducer;
